
import {Component, Vue} from 'vue-property-decorator';
import AppPageHeader from "@/components/AppPageHeader.vue";
import CorpsIntro from "@/modules/Corps/components/CorpsIntro.vue";

@Component({
  components: {
    CorpsIntro,
    AppPageHeader,
  },
})
export default class PageCorps extends Vue {
  $refs: any;
  isLoading: boolean = true;


  async created() {
    try {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('book/initBooksForPage', this.$route.name);
      await this.$store.dispatch('corps/init');
      await this.$store.dispatch('initialized');
      this.isLoading = false;
    }
    catch (error) { await this.$store.dispatch('handleError', error) }
  }
}
